
import { AsyncThunk, AsyncThunkConfig, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchByIdWithoutInputFactory } from "./fetchByIdFactory";
import { GET_TERMINALS_INFO_BY_IDS, TerminalInfo, TerminalsByIdsResponse } from "../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getTerminalsCall";


export const fetchTerminalsByIdsThunk = createAsyncThunk(
  `terminals/fetchByIds`,
  fetchByIdWithoutInputFactory<TerminalsByIdsResponse, TerminalInfo, number>(GET_TERMINALS_INFO_BY_IDS, (terminalResponse) => terminalResponse.data.terminal.infoByIds)
) satisfies AsyncThunk<TerminalInfo[], number[], AsyncThunkConfig> as AsyncThunk<TerminalInfo[], number[], AsyncThunkConfig>